import {useCallback} from 'react';

import mixpanel from 'mixpanel-browser';

// NoOps for mixpanel if mixpanel is not initialized
let analyticsLib = {
    identify: () => {},
    init: () => {},
    register: () => {},
    reset: () => {},
    track: () => {},
};

if (import.meta.env.HAL_MIXPANEL_TOKEN) {
    analyticsLib = mixpanel;
}

export default function useAnalytics() {
    const init = useCallback((token, config) => {
        analyticsLib.init(token, config);
    }, []);
    const identify = useCallback(id => {
        analyticsLib.identify(String(id));
    }, []);
    const register = useCallback(properties => {
        analyticsLib.register(properties);
    }, []);
    const reset = useCallback(() => {
        analyticsLib.reset();
    }, []);
    const track = useCallback(
        (eventName, properties) => analyticsLib.track(eventName, properties),
        [],
    );

    return {
        identify,
        init,
        register,
        reset,
        track,
    };
}
